import Vue from 'vue'
import Router from 'vue-router'

import Base from '@/components/Base'
import HomePage from '@/components/pages/home/index'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      redirect: to => {
        return '/home'
      }
    },
    // 404页面
    {
      path: '*',
      name: '404',
      component: function (resolve, reject) {
        require(['@/components/pages/error/404'], resolve)
      }
    },
    // 首页
    {
      path: '/home',
      name: '会员中心',
      component: Base,
      redirect: to => {
        return '/home/index'
      },
      children: [{
        path: 'index',
        name: '会员中心',
        component: HomePage
      }]
    },
    // 首页
    {
      path: '/help',
      name: '帮助',
      component: Base,
      redirect: to => {
        return '/help/index'
      },
      children: [{
        path: 'index',
        name: '帮助',
        component: function (resolve, reject) {
          require(['@/components/pages/help/index'], resolve)
        }
      },
      {
        path: 'more',
        name: '帮助',
        component: function (resolve, reject) {
          require(['@/components/pages/help/more'], resolve)
        }
      }
      ]
    },
    // 登录
    {
      path: '/login',
      name: 'login',
      component: Base,
      redirect: to => {
        return '/login/index'
      },
      // desc: '登录',
      children: [{
        path: 'index',
        name: '登录',
        component: function (resolve, reject) {
          require(['@/components/pages/login/login'], resolve)
        }
      }]
    },
    // 注册
    {
      path: '/register',
      name: 'register',
      component: Base,
      redirect: to => {
        return '/register/index'
      },
      // desc: '注册',
      children: [{
        path: 'index',
        name: '注册',
        component: function (resolve, reject) {
          require(['@/components/pages/register/register'], resolve)
        }
      }]
    },
    // 个人资料
    {
      path: '/personal',
      name: '个人资料',
      component: Base,
      redirect: to => {
        return '/personal/index'
      },
      // eslint-disable-next-line no-sparse-arrays
      children: [
        // 个人资料首页
        {
          path: 'index',
          name: '个人资料',
          component (resolve, reject) {
            require(['@/components/pages/personal/index'], resolve)
          }
        },
        // 修改头像页
        {
          path: 'updateLogo',
          name: '个人资料',
          component (resolve, reject) {
            require(['@/components/pages/personal/updateLogo'], resolve)
          }
        },,
        // 修改头像页
        {
          path: 'updateName',
          name: '个人资料',
          component (resolve, reject) {
            require(['@/components/pages/personal/updateName'], resolve)
          }
        },
        // 修改手机号页
        {
          path: 'updatePhone',
          name: '修改手机号',
          component (resolve, reject) {
            require(['@/components/pages/personal/updatePhone'], resolve)
          }
        }
      ]
    },
    {
      path: '/coupon',
      name: '优惠券',
      component: Base,
      redirect: to => {
        return '/coupon/index'
      },
      children: [{
        path: 'index',
        name: '优惠券',
        component (resolve, reject) {
          require(['@/components/pages/coupon/index'], resolve)
        }
      },
      {
        path: 'couponDetails',
        name: '优惠券详情',
        component (resolve, reject) {
          require(['@/components/pages/coupon/couponDetails'], resolve)
        }
      }
      ]
    },
    // 积分
    {
      path: '/integral',
      name: '积分',
      component: Base,
      redirect: to => {
        return '/integral/index'
      },
      children: [
      // 积分首页
        {
          path: 'index',
          name: '我的积分',
          component (resolve, reject) {
            require(['@/components/pages/integral/index'], resolve)
          }
        },
        // 积分明细列表
        {
          path: 'list',
          name: '积分明细',
          component (resolve, reject) {
            require(['@/components/pages/integral/list'], resolve)
          }
        },
        // 积分明细
        {
          path: 'detailed',
          name: '积分明细',
          component (resolve, reject) {
            require(['@/components/pages/integral/detailed'], resolve)
          }
        },
        // 积分商城
        {
          path: 'mall',
          name: '积分商城',
          component (resolve, reject) {
            require(['@/components/pages/integral/mall'], resolve)
          }
        }, {
          path: 'exchange',
          name: '积分兑换记录',
          component (resolve, reject) {
            require(['@/components/pages/integral/exchange'], resolve)
          }
        }, {
          path: 'exchangeDetail',
          name: '积分兑换详情',
          component (resolve, reject) {
            require(['@/components/pages/integral/exchangeDetail'], resolve)
          }
        },
        {
          path: 'couponDetail',
          name: '优惠券详情',
          component (resolve, reject) {
            require(['@/components/pages/integral/couponDetail'], resolve)
          }
        },
        {
          path: 'goodDetail',
          name: '商品详情',
          component (resolve, reject) {
            require(['@/components/pages/integral/goodDetail'], resolve)
          }
        },
        {
          path: 'pay',
          name: '支付',
          component (resolve, reject) {
            require(['@/components/pages/integral/pay'], resolve)
          }
        }
      ]
    },
    // 余额
    {
      path: '/spareMoney',
      name: '余额',
      component: Base,
      redirect: to => {
        return '/spareMoney/index'
      },
      children: [
      // 余额首页
        {
          path: 'index',
          name: '我的余额',
          component (resolve, reject) {
            require(['@/components/pages/spareMoney/index'], resolve)
          }
        },
        // 余额明细列表
        {
          path: 'list',
          name: '余额列表',
          component (resolve, reject) {
            require(['@/components/pages/spareMoney/list'], resolve)
          }
        },
        // 余额明细
        {
          path: 'detailed',
          name: '余额明细',
          component (resolve, reject) {
            require(['@/components/pages/spareMoney/detailed'], resolve)
          }
        }
      ]
    },
    // 礼品卡
    {
      path: '/giftCard',
      name: '礼品卡',
      component: Base,
      redirect: to => {
        return '/giftCard/index'
      },
      children: [
      // 礼品卡首页
        {
          path: 'index',
          name: '礼品卡首页',
          component (resolve, reject) {
            require(['@/components/pages/giftCard/index'], resolve)
          }
        },
        // 礼品卡详情
        {
          path: 'detailed',
          name: '礼品卡首页',
          component (resolve, reject) {
            require(['@/components/pages/giftCard/detailed'], resolve)
          }
        },
        // 我的礼品卡
        {
          path: 'my',
          name: '我的礼品卡',
          component (resolve, reject) {
            require(['@/components/pages/giftCard/my'], resolve)
          }
        }
      ]
    },
    // 寄存
    {
      path: '/deposit',
      name: '寄存',
      component: Base,
      redirect: to => {
        return '/deposit/index'
      },
      children: [
        {
          path: 'index',
          name: '寄存',
          component (resolve, reject) {
            require(['@/components/pages/deposit/index'], resolve)
          }
        },
        {
          path: '/deposit/record',
          name: '寄存/提取记录',
          component (resolve, reject) {
            require(['@/components/pages/deposit/record'], resolve)
          }
        },
        {
          path: '/deposit/detail',
          name: '寄存详情',
          component (resolve, reject) {
            require(['@/components/pages/deposit/detail'], resolve)
          }
        }
      ]
    },
    // 礼品卡
    {
      path: '/assess',
      name: '评价',
      component (resolve, reject) {
        require(['@/components/pages/assess/assess'], resolve)
      }
    }

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js